module.exports = __webpack_public_path__ + "static/Planet_3-82ea544813247bd39a683905c7671671.png";